/**
 * Parse pasted/typed emails for batch invite / add-user.
 * Accepts commas, semicolons, whitespace, and newlines as separators.
 * @param {string} raw
 * @returns {string[]} unique lowercased emails in input order
 */
export function parseBatchEmails(raw) {
  const seen = new Set();
  const out = [];
  for (const part of String(raw || "").split(/[\s,;]+/)) {
    const em = part.trim().toLowerCase();
    if (!em || seen.has(em)) continue;
    seen.add(em);
    out.push(em);
  }
  return out;
}

export function isValidEmail(s) {
  const t = String(s || "").trim();
  if (!t) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(t);
}
